import { useEffect } from 'react'

declare global {
  interface Window {
    dataLayer: Record<string, any>
  }
}

const useGa4 = () => {
  const PRODUCT = 'COL'

  // claim_form_path
  const ga4_claimFormPath = (fieldsObject: {
    case_type: string
    step: string
  }) => {
    eventLog('claim_form_path', fieldsObject)
    window.dataLayer.push({
      event: 'claim_form_path',
      product: PRODUCT,
      ...fieldsObject,
    })
  }

  // form_field_click
  const ga4_formFieldClick = (fieldsObject: {
    case_type?: string
    step?: string
    form_name?: string
    field_name?: string
  }) => {
    eventLog('form_field_click', fieldsObject)
    window.dataLayer.push({
      event: 'form_field_click',
      product: PRODUCT,
      ...fieldsObject,
    })
  }

  // form_field_error
  type Ga4FormFieldErrorParams = {
    case_type?: string
    step?: string
    form_name?: string
    field_name?: string
    error_message?: string
  }

  const ga4_formFieldError = (fieldsObject: Ga4FormFieldErrorParams) => {
    eventLog('form_field_error', fieldsObject)
    window.dataLayer.push({
      event: 'form_field_error',
      product: PRODUCT,
      ...fieldsObject,
    })
  }

  // user_data
  const ga4_userData = (fieldsObject: {
    user_id: string
    is_customer: boolean
    page_subcategory: string
  }) => {
    eventLog('user_data', fieldsObject)
    window.dataLayer.push({
      event: 'user_data',
      page_category: PRODUCT,
      user_id: fieldsObject.user_id,
      is_customer: `${fieldsObject.is_customer}`,
      page_subcategory: fieldsObject.page_subcategory,
    })
  }

  // click_cta
  const ga4_clickCta = (fieldsObject: { cta_name: string }) => {
    eventLog('click_button', fieldsObject)
    window.dataLayer.push({ event: 'click_button', ...fieldsObject })
  }

  function noAttributeIsNull(obj: any): boolean {
    return Object.entries(obj).findIndex(([key, value]) => value == null) < 0
  }

  function eventLog(eventName: string, fieldsObject: any) {
    const prompt = 'GA4::event'
    if (noAttributeIsNull(fieldsObject)) {
      // console.log(`${prompt} ${eventName}: `, fieldsObject)
    } else {
      console.error(`${prompt} ${eventName} incomplete: `, fieldsObject)
    }
  }

  useEffect(() => {
    return () => {
      // Clean up function (if needed)
    }
  }, [])

  return {
    ga4_claimFormPath,
    ga4_formFieldClick,
    ga4_formFieldError,
    ga4_userData,
    ga4_clickCta,
  }
}

export default useGa4
